import { render, staticRenderFns } from "./ResultBigRoad.vue?vue&type=template&id=59911e8b&"
import script from "./ResultBigRoad.vue?vue&type=script&lang=js&"
export * from "./ResultBigRoad.vue?vue&type=script&lang=js&"
import style0 from "./ResultBigRoad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports